export function Footer() {
  return (
    <footer class="site-footer" role="contentinfo">
      <p class="site-footer__copy">&copy; {new Date().getFullYear()} Sage. All rights reserved.</p>
    </footer>
  );
}
